
import { useEffect, useRef, useState } from 'react'
const LazyLoadImage = ({ height, width, src, style, alt }) => {
    const target = useRef()
    const image = useRef()
    // const [loadImage, setLoadImage] = useState(false)
    const [intersecting, setIntersecting] = useState(false)
    
    useEffect(() => {
        // const options = {rootMargin: '0px 0px 200px 0px'}
        const options = {}
        const imageObserver = new IntersectionObserver((entries, imgObserver) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting){
                    return
                }
                else{
                    setIntersecting(true)
                }
                imgObserver.unobserve(entry.target)
            })
        }, options)
        imageObserver.observe(target.current)
    }, [])

    const hidePlaceHolder = () => {
        if (target.current){
            target.current.style.display = "none"
        }
    }
    const showImage = () => {
        image.current.style.opacity = "1";
    }
    const BlockImage = () => {
        if (image.current){
            image.current.style.display = "block"
            setTimeout(showImage, 30)
        }
    }
    const ImageLoaded = () => {
        // setLoadImage(true)
        target.current.style.opacity = '0';
        setTimeout(hidePlaceHolder, 200)
        setTimeout(BlockImage, 200)

    }
    const ImageStyle = {
        ...style,
        // display: loadImage ? "block" : "none"
        display: 'none',
        opacity: '0',
        transition: '0.2s opacity ease-in-out',
    }
    const placeHolderStyle = {
        height,
        width,
        // display: loadImage ? "none" : "block"
        display: "block",
        opacity: '1',
        transition: '0.2s opacity ease-in-out',

    }
    return (
        <>
            {intersecting && <img src={src} alt={alt} width={width} style={ImageStyle} onLoad={ImageLoaded} ref={image}/>}
            <div className="ui placeholder" ref={target} style={placeHolderStyle}>
                <div className="image"></div>
            </div>
        </>
    )
}

export default LazyLoadImage